export default {
  businessDescription: {
    required: true,
    minLength: 10,
    maxLength: 2000,
    textArea: true,
  },
};



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/businessDescriptionValidationRules.js